import React, { Component } from 'react';

class TranslateNamePermission extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {columnFlag} = this.props;
    if (columnFlag === 'group') {
      return <span>{this.props.language == 'ch' ? this.props.data.cn_group_name ? this.props.data.cn_group_name : this.props.data.group_name : this.props.data.group_name}</span>;
    } else if (columnFlag === 'category') {
      return <span>{this.props.language == 'ch' ? this.props.data.cn_category_name ? this.props.data.cn_category_name : this.props.data.category_name : this.props.data.category_name}</span>;
    } else {
      return <span>{this.props.language == 'ch' ? this.props.data.cn_name ? this.props.data.cn_name : this.props.data.name : this.props.data.name}</span>;
    }
  }
}

export default TranslateNamePermission;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/TranslatePermission.jsx